import { render, staticRenderFns } from "./UnidadDetalle.vue?vue&type=template&id=69a47173&scoped=true"
import script from "./UnidadDetalle.vue?vue&type=script&lang=js"
export * from "./UnidadDetalle.vue?vue&type=script&lang=js"
import style0 from "./UnidadDetalle.vue?vue&type=style&index=0&id=69a47173&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a47173",
  null
  
)

export default component.exports